import {
  DonutChartBar,
  type IDonutChartBar,
} from 'shared/ui/DonutChart/ui/DonutChartBar/DonutChartBar'
import styles from './styles.module.scss'

type IDonutChartBarsProps = {
  items: IDonutChartBar[]
}

export const DonutChartBars = ({ items }: IDonutChartBarsProps) => {
  return (
    <div className={styles.wrap}>
      {items.map((item) => {
        return <DonutChartBar key={item.title} {...item} />
      })}
    </div>
  )
}
